/* eslint-disable camelcase */
/* eslint-disable no-undef */
import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter, Route } from 'react-router-dom';
import { Provider } from 'react-redux';
import QueryString from 'query-string';
import Cookies from 'universal-cookie';
import jwtDecode from 'jwt-decode';
// eslint-disable-next-line import/no-extraneous-dependencies
import 'react-app-polyfill/ie11';
// eslint-disable-next-line import/no-extraneous-dependencies
import 'react-app-polyfill/stable';
import Routes from './routes';
import store from './store/config';
import { SET_LOGGED_IN_TOKEN } from './types/Types';
import { getLoginUrl } from './utility/common';
import './index.css';
import * as serviceWorker from './serviceWorker';

// eslint-disable-next-line spaced-comment
const isIE = /*@cc_on!@*/false || !!document.documentMode;
const cookie = new Cookies();
let aToken = localStorage.getItem('access_token');
let iToken = localStorage.getItem('id_token');//cookie.get('id_token');
let removeHash = false;
let isRedirectToLogin = false;

const ID_TOKEN_KEY = "id_token";
const ID_TOKEN_EXP_KEY = "id_token_expiry";
const ACCESS_TOKEN_KEY = "access_token";

/*console.log('before validation start AccessToken from local:', aToken);
console.log('before validation start IdToken from cookie:', iToken);
console.log('before validation start isIE:', isIE);*/

if (window.location.hash) {
  const parsedHash = QueryString.parse(window.location.hash);
  const { id_token, access_token } = parsedHash;
  //console.log('Received id_token:', id_token);
  //console.log('Received access_token:', access_token);
  if (id_token && access_token) {
    const userData = jwtDecode(id_token);
    const nonce = cookie.get('nonce');
    const date = new Date();
    if (date.getTime() > userData.exp * 1000) {
      console.log('expiry');
      isRedirectToLogin = true;
    }
    if (nonce && nonce === userData.nonce) {
      console.log('nonce');
      isRedirectToLogin = true;
    }
    date.setTime(userData.exp * 1000);
    // secure: true, httpOnly: true
    /*cookie.set('id_token', id_token, {
      path: '/', expires: date, secure: true,
    });*/
    localStorage.setItem('access_token', access_token);
    localStorage.setItem("id_token", id_token); // existing
    localStorage.setItem("id_token_expiry", date.getTime()); // NEW
    aToken = access_token;
    iToken = id_token;
    removeHash = true;
  }
}
console.log(isRedirectToLogin);
store.dispatch({
  type: SET_LOGGED_IN_TOKEN,
  idToken: iToken,
  accessToken: aToken,
});

if (isRedirectToLogin) {
  window.location.href = getLoginUrl();
} else if (removeHash) {
  window.location.href = '/';
}

/*console.log('aToken not empty:', aToken);
console.log('iToken not empty:', iToken);
console.log('isIE must be false:', isIE);*/

if ((!aToken || !iToken) && !isIE) {
  window.location.href = getLoginUrl();
}

const expiry = localStorage.getItem(ID_TOKEN_EXP_KEY);
console.log('Exp from local: ',expiry);
if (!expiry) {
  window.location.href = getLoginUrl();
}

if (Date.now() > Number(expiry)) {
    localStorage.removeItem(ID_TOKEN_KEY);
    localStorage.removeItem(ID_TOKEN_EXP_KEY);
    localStorage.removeItem(ACCESS_TOKEN_KEY); // avoid half-auth state
}


ReactDOM.render(
  <BrowserRouter>
    <Provider store={store}>
      <Route component={Routes} />
    </Provider>
  </BrowserRouter>,
  // eslint-disable-next-line no-undef
  document.getElementById('root'),
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
